module.exports = __webpack_public_path__ + "static/media/help-03.2352c45d.svg";